import styled from 'styled-components';
export const InputForm = styled.div`
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .errorText {
    color: #e6000f;
  }

  .label {
    display: block;
    height: 30px;
  }
`;
